/**
 *    Congress calculator
 */

(function ($) {
  Drupal.behaviors.heroCongressCalculator = {
    attach(context, settings) {
      // elements
      const $wrapper = $('.vb-hero--congress-calculator');
      const $form = $wrapper.find('.vb-hero__form');
      const $buttonSubmit = $wrapper.find('button[type="submit"]');
      const $buttonCalcAgain = $wrapper.find('.vb-button--calc-again');
      const $buttonDropdown = $wrapper.find('.vb-congress-calculator__toggle');
      const $valueMain = $wrapper.find('.vb-congress-calculator__value--main');
      const $valueMoney = $wrapper.find('.vb-congress-calculator__value--money');
      const $valueParticipants = $wrapper.find('.vb-congress-calculator__value--participants');
      const $valueDays = $wrapper.find('.vb-congress-calculator__value--days');
      const $suffixDays = $wrapper.find('.vb-congress-calculator__suffix--days');
      const $dynamicText = $wrapper.find('.vb-congress-calculator__text--dynamic');
      const $inRangeTexts = $wrapper.find('.vb-congress-calculator__texts--in-range');
      const $tooHighTexts = $wrapper.find('.vb-congress-calculator__texts--too-high');

      // values
      let days = 1;
      let participant = 1;
      let money = 1;
      const maxResultValue = 99950;

      // suffix
      const suffixDaysSingular = $suffixDays.data('singular');
      const suffixDaysPlural = $suffixDays.data('plural');

      // submit button
      $buttonSubmit.on('click', (event) => {
        event.preventDefault();

        // money
        if (!$wrapper.find('[name="vb-event-type"]:checked').length) {
          $wrapper.find('#face-to-face-event').prop('checked', true).trigger('change');
        }

        // get values
        money = parseInt($wrapper.find('[name="vb-event-type"]:checked').val());
        days = parseInt($wrapper.find('#vb-connected-inline-datepicker__input--congress-calculator').attr('data-days'));
        participant = $wrapper.find('#vb-field--event-participant').val() ? parseInt($wrapper.find('#vb-field--event-participant').val()) : 1;

        // fix days
        if (isNaN(days)) {
          days = 1;
        }

        // suffix
        if (days === 1) {
          $suffixDays.html(suffixDaysSingular);
        } else {
          $suffixDays.html(suffixDaysPlural);
        }

        // small text
        switch (money) {
          case 35:
            $dynamicText.html($dynamicText.data('text-hybrid'));
            break;
          default:
            $dynamicText.html($dynamicText.data('text-face-to-face'));
            break;
        }

        // result value
        let resultValue = participant * (money/* + promotion + decentralizedMeetings */) * days;

        // max result value behaviour
        if (resultValue > maxResultValue) {
          // set result value to the max
          resultValue = maxResultValue;

          // show corrects texts
          $tooHighTexts.addClass('vb-active');
        } else {
          // show corrects texts
          $tooHighTexts.removeClass('vb-active');
        }

        // print values
        $valueMain.html(resultValue.toLocaleString());
        $valueMoney.html(money);
        $valueParticipants.html(participant);
        $valueDays.html(days);

        // start loading animation
        $form.addClass('vb-start-animation vb-submit-animation');

        setTimeout(() => {
          // show results
          $wrapper.addClass('vb-hero--show-results');

          setTimeout(() => {
            // end loading animation
            $form.removeClass('vb-submit-animation');
            setTimeout(() => {
              $form.removeClass('vb-start-animation');
            }, 600);
          }, 600);
        }, 600);
      });

      // click 'calc again' button
      $buttonCalcAgain.on('click', () => {
        // start loading animation
        $form.addClass('vb-start-animation vb-submit-animation');

        // close open dropdowns
        $('.vb-congress-calculator__dropdown').removeClass('vb-open');

        setTimeout(() => {
          // hide results
          $wrapper.removeClass('vb-hero--show-results');

          // end loading animation
          $form.removeClass('vb-submit-animation');
          setTimeout(() => {
            $form.removeClass('vb-start-animation');
          }, 600);
        }, 600);
      });

      // change info text
      $('[name="vb-event-type"]').on('change', function () {
        const $input = $(this);
        let id = $input.attr('id');

        if (!$input.is(':checked')) {
          id = 'basic';
        }

        $(`.vb-info-text[data-info-type="${id}"]`)
          .removeClass('hidden')
          .siblings()
          .addClass('hidden');
      });

      // dropdown toggle button
      const toggleDropdown = function (button) {
        $(button).closest('.vb-congress-calculator__dropdown').toggleClass('vb-open');

        if (button.getAttribute('aria-expanded') === 'false') {
          button.setAttribute('aria-expanded', 'true');
        } else {
          button.setAttribute('aria-expanded', 'false');
        }
      };

      $buttonDropdown
        .on('click', function () {
          toggleDropdown(this);
        })
        .on('keydown', function (event) {
          if (event.key === 'Enter') {
            toggleDropdown(this);
          }
        });

      $(document.documentElement).on('keydown', (event) => {
        if (event.key === 'Escape') {
          const toggleButton = document.querySelector('.vb-congress-calculator__toggle[aria-expanded="true"]');
          if (toggleButton) {
            toggleDropdown(toggleButton);
          }
        }
      });
    },
  };
}(jQuery));

// end of hero--congress-calculator.js
